'use client';

import { useEffect, useState } from 'react';
import { Receipt, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAdminMode } from '@/hooks/useAdminMode';
import OrderSummary from './OrderSummary';

export default function OrderSummaryPanel() {
  const { isAdmin } = useAdminMode();
  const [open, setOpen] = useState(false);

  // 서버 렌더는 항상 비관리자(cache 없음) → 첫 클라이언트 렌더도 비관리자로 맞춰
  // 하이드레이션 불일치 방지. 마운트 후에만 관리자 전용 UI 노출.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const showAdmin = mounted && isAdmin;

  return (
    <>
      {/* PC: 우측 sticky 사이드바 */}
      <aside className="hidden lg:block lg:w-[360px] lg:flex-shrink-0">
        <OrderSummary adminMode={showAdmin} />
      </aside>

      {/* 모바일 (관리자 모드): 우측 슬라이드 드로어 */}
      {showAdmin && (
        <>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="lg:hidden fixed right-0 top-1/3 z-30 bg-[#1A3A5C] text-white pl-2 pr-2.5 py-3 rounded-l-lg shadow-md flex items-center gap-1"
            aria-label="주문 요약 열기"
          >
            <Receipt className="w-4 h-4" />
            <span className="text-xs font-medium">요약</span>
          </button>

          <div
            className={cn(
              'lg:hidden fixed inset-0 z-40 bg-black/40 transition-opacity',
              open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
            )}
            onClick={() => setOpen(false)}
          />

          <div
            className={cn(
              'lg:hidden fixed top-0 right-0 z-50 h-full w-[90%] max-w-[360px] bg-gray-50 shadow-xl overflow-y-auto transition-transform',
              open ? 'translate-x-0' : 'translate-x-full',
            )}
          >
            <div className="sticky top-0 z-10 flex justify-end bg-gray-50 p-2">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="p-1 text-gray-500 hover:text-gray-700"
                aria-label="닫기"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="px-3 pb-3">
              <OrderSummary adminMode={showAdmin} />
            </div>
          </div>
        </>
      )}
    </>
  );
}
